export default {
  default: () => import("/Users/jdo/org/brx/artifacts_frontend_brx/layouts/default.vue")
}